import React from "react"
import { connect } from "react-redux"
import LinkIcon from "../../resources/svgs/Link.svg"
import Highlighter from "react-highlight-words"
import { store } from "../../app/store"
import { CopyToClipboard } from "react-copy-to-clipboard"
import articlesTypeConsts from "./articlesType"

class ArticleDetailsCell extends React.Component {
  render() {
    let article = this.props.article
    let isRsoc = article.post_style === articlesTypeConsts.ads_for_search.name
    let url = `${article?.url}${isRsoc ? "?rsoc=1" : ""}`
    let search_full_text = store.getState().articles.filters.get("ARTICLE_FULL_TEXT")
    let filterValue =
      search_full_text && search_full_text.includeFilters[0] ? search_full_text.includeFilters[0]["filterValue"] : []

    return (
      <>
        <div className="d-flex full-width article-details-cell">
          {article?.first_image_url ? (
            <div className="article-image">
              {<img src={article?.first_image_url} loading="lazy" className="article-image" />}
            </div>
          ) : null}
          <div className="article-details font-semibold">
            <div className="content-text">
              {article?.article_name ? (
                <div className="article-name">
                  <Highlighter searchWords={filterValue} autoEscape={true} textToHighlight={article?.article_name} />
                </div>
              ) : null}
              <div className="article-title">
                <Highlighter searchWords={filterValue} autoEscape={true} textToHighlight={article?.title} />
              </div>
            </div>
            <div className="link-block">
              <CopyToClipboard text={url} tooltip>
                <div data-tip={"Copy Link"} data-class="tooltip-custom type-icon-info shrink-tip">
                  <LinkIcon class="link-icon" />
                </div>
              </CopyToClipboard>
              <a href={url} target="_blank" className="article-link">
                <div className="article-url">
                  <Highlighter searchWords={filterValue} autoEscape={true} textToHighlight={article?.url} />
                </div>
              </a>
            </div>
          </div>
        </div>
      </>
    )
  }
}

function mapStateToProps(state) {
  return {}
}

export default connect(mapStateToProps)(ArticleDetailsCell)
